'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {

    var columns = [{
        id: 'edit',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                { iconClassName: 'material-icons', onClick: function onClick() {
                        return props.onClickEditRole(col.original.id);
                    } },
                'edit'
            );
        }
    }, {
        Header: 'Id',
        accessor: 'id',
        width: 240
    }, {
        Header: 'Nome',
        accessor: 'name'
    }, {
        Header: 'Cargo agrupado',
        accessor: 'roleCategory'
    }];

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactTable2.default, {
            data: props.roles,
            columns: columns,
            loading: props.loading,
            previousText: 'Anterior',
            nextText: 'Pr\xF3xima',
            loadingText: 'Carregando...',
            noDataText: 'N\xE3o foram encontrados Cargos para este filtro',
            pageText: 'P\xE1gina',
            ofText: 'de',
            rowsText: 'linhas',
            showPaginationBottom: true,
            width: 100,
            defaultPageSize: 10,
            filterable: true
        })
    );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/roles/RolesList.js
// module id = 3288
// module chunks = 0